/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _isSelectionEnabled = _interopRequireDefault(require("./isSelectionEnabled"));
var _isSelectionControlled = _interopRequireDefault(require("./isSelectionControlled"));
var isMultiSelect = function isMultiSelect(props) {
  if (!(0, _isSelectionEnabled.default)(props)) {
    return false;
  }
  if (props.multiSelect !== undefined) {
    return !!props.multiSelect;
  }
  var controlled = (0, _isSelectionControlled.default)(props);
  var isMulti = controlled ? !!((0, _typeof2.default)(props.selected) == 'object' && props.selected) || typeof props.selected === 'boolean' : !!((0, _typeof2.default)(props.defaultSelected) == 'object' && props.defaultSelected) || typeof props.defaultSelected === 'boolean' || props.checkboxColumn;
  return !!isMulti;
};
var _default = isMultiSelect;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/hooks/useSelection/isMultiSelect.js
// module id = 610
// module chunks = 0